<mat-card>
    <mat-card-header>
        <mat-card-title>Seite nicht gefunden</mat-card-title>
    </mat-card-header>

    <mat-card-content class="mb-4">
        <p>Die angeforderte Seite konnte nicht gefunden werden.</p>

        <p>
            Sie werden an die
            <a
                [routerLink]="this.redirectUrl"
                [state]="{ navigatedBy: EventTrackerNavigationReasons.NotFoundPageButton }"
                class="cursor-pointer text-blue-400 underline"
            >
                Startseite
            </a>
            weitergeleitet.
        </p>
    </mat-card-content>

    <mat-card-footer>
        <mat-progress-bar mode="determinate" [value]="progressBarValueObs | async"></mat-progress-bar>
    </mat-card-footer>
</mat-card>
